import {
  Colors,
  Icon,
  InlineChildren,
  Inset,
  StackChildren,
  Text,
} from '@doordash/design-language'
import * as React from 'react'
import { i18nKeys } from 'translationTypes'
import i18n from '../../../../i18n'

interface NccShareCheckListProps {
  items: NccShareCheckListItem[]
}

interface NccShareCheckListItem {
  icon: typeof Icon.Types
  text: string
}

const NCC_SHARE_CHECKLIST_ITEMS: NccShareCheckListItem[] = [
  {
    icon: Icon.Types.Office,
    text: i18n.t(i18nKeys.backgroundCheckShare__nccStart__requirement1),
  },
  {
    icon: Icon.Types.TimeLine,
    text: i18n.t(i18nKeys.backgroundCheckShare__nccStart__requirement2),
  },
  {
    icon: Icon.Types.ReceiptLine,
    text: i18n.t(i18nKeys.backgroundCheckShare__nccStart__requirement3),
  },
]

const NccShareCheckList: React.FC<NccShareCheckListProps> = ({ items }) => {
  return (
    <StackChildren>
      {items.map(item => (
        <InlineChildren key={item.text}>
          <Icon
            type={item.icon}
            size={Icon.Sizes.Medium}
            useDefaultColors={true}
          />
          <Text styles={Text.Styles.Body1} color={Colors.TextSecondary}>
            {item.text}
          </Text>
        </InlineChildren>
      ))}
    </StackChildren>
  )
}

export const NccShareStart: React.FC = () => {
  return (
    <Inset horizontalSize={Inset.Sizes.None} verticalSize={Inset.Sizes.Small}>
      <StackChildren size={StackChildren.Sizes.Large}>
        <Text styles={Text.Styles.Body1} color={Colors.TextSecondary}>
          {i18n.t(i18nKeys.backgroundCheckShare__nccStart__requirementHeader)}
        </Text>
        <NccShareCheckList items={NCC_SHARE_CHECKLIST_ITEMS} />
        <Text styles={Text.Styles.Body1} color={Colors.TextSecondary}>
          {i18n.t(i18nKeys.backgroundCheckShare__nccStart__goBackAndStartNew)}
        </Text>
      </StackChildren>
    </Inset>
  )
}
